import Vue from 'vue';
import VueHead from 'vue-head';

Vue.use(VueHead);

function head() {
    const msg = this.$i18n.messages[this.$store.state.locale];
    return {
        title: {
            inner: msg.general.name,
            complement: msg.general.description
        },
        // Meta tags
        meta: [{
            name: 'application-name',
            content: msg.general.name
        }, {
            name: 'description',
            content: msg.general.description,
            id: 'desc'
        },
        // Twitter
        {
            name: 'twitter:title',
            content: `${msg.general.name} | ${msg.general.description}`
        },
        // with shorthand
        {
            n: 'twitter:description',
            c: `${msg.messages.discovermoreon} Kalamaio.com`
        },
        {
            property: 'og:title', content: `${msg.general.name} | ${msg.general.description}`
        },
        {
            property: 'og:desription', content: `${msg.messages.discovermoreon} Kalamaio.com`
        }]
    };
}

export default head;
